if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        // ----- form bootstrapping -----
        this.form = this.querySelector("form");
        if (!this.form) return;

        const idField = this.form.querySelector("[name=id]");
        if (idField) idField.disabled = false;

        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));

        this.submitButton = this.querySelector('[type="submit"]');
        if (document.querySelector("cart-drawer")) {
          this.submitButton.setAttribute("aria-haspopup", "dialog");
        }

        // cart UI handle (drawer/notification) if present
        this.cart =
          document.querySelector("cart-drawer") ||
          document.querySelector("cart-notification") ||
          null;
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();
        this.submitButton.setAttribute("aria-disabled", true);

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        if (this.cart) {
          const sections = this.cart.getSectionsToRender
            ? this.cart.getSectionsToRender().map((s) => s.id)
            : [];
          formData.append("sections", sections);
          formData.append("sections_url", window.location.pathname);
          if (this.cart.setActiveElement)
            this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        // helper: update cart bubble + explode
        const updateCartBubble = () =>
          fetch("/cart.js")
            .then((r) => r.json())
            .then((cart) => {
              const cartIcon = document.querySelector("#cart-icon-bubble");
              if (!cartIcon) return;

              cartIcon.classList.add("cart-explode");
              setTimeout(() => cartIcon.classList.remove("cart-explode"), 800);

              const countBubble = cartIcon.querySelector(".cart-count-bubble");
              if (countBubble) {
                countBubble.textContent = cart.item_count;
                countBubble.classList.toggle("hide", cart.item_count === 0);
              }
            });

        // helper: unified toast signal for cart-toast.js
        const fireToast = (message = "Product added to cart") =>
          document.dispatchEvent(
            new CustomEvent("sadwich:cart-added", { detail: { message } })
          );

        fetch(`${routes.cart_add_url}`, config)
          .then((resp) => resp.json())
          .then((resp) => {
            if (resp.status) {
              // /cart/add error (e.g., sold out)
              this.handleErrorMessage(resp.description);

              if (this.submitButton) {
                this.submitButton.classList.add("is-disabled");
                this.submitButton.setAttribute("disabled", "disabled");
                this.submitButton.setAttribute("aria-disabled", "true");
                this.submitButton.textContent = "Sold out";
              }

              document.dispatchEvent(
                new CustomEvent("sadwich:cart-error", { detail: resp })
              );
              this.error = true;
              return;
            }

            // success
            this.error = false;
            if (typeof publish === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: "product-form" });
            }

            // manual bubble update first, then toast with correct timing
            return updateCartBubble().finally(() => {
              const quickAddModal = this.closest("quick-add-modal");
              if (quickAddModal) {
                document.body.addEventListener(
                  "modalClosed",
                  () => {
                    setTimeout(() => fireToast("Product added to cart"));
                  },
                  { once: true }
                );
                if (quickAddModal.hide) quickAddModal.hide(true);
              } else {
                fireToast("Product added to cart");
              }

              if (typeof AOS !== "undefined") AOS.init();
            });
          })
          .catch((e) => console.error(e))
          .finally(() => {
            this.submitButton.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty")) {
              this.cart.classList.remove("is-empty");
            }
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            if (typeof AOS !== "undefined") AOS.init();
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;

        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          if (typeof errorMessage === "object") {
            const formatted = Object.entries(errorMessage)
              .map(([field, messages]) => `${field}: ${messages.join(", ")}`)
              .join(" | ");
            this.errorMessage.textContent = formatted;
          } else {
            this.errorMessage.textContent = errorMessage;
          }
        }
      }
    }
  );

  // --- your sticky add-to-cart code (unchanged) ---
  let removedElements = { mobile: [], desktop: [] };

  function removeElementsByScreenSize(container = document) {
    if (window.matchMedia("(max-width: 990px)").matches) {
      document.querySelectorAll(".hide-mobile").forEach((el) => {
        removedElements.desktop.push({
          parent: el.parentNode,
          element: el,
          nextSibling: el.nextSibling,
        });
        el.remove();
      });

      removedElements.mobile.forEach(({ parent, element, nextSibling }) => {
        if (nextSibling && nextSibling.parentNode === parent) {
          parent.insertBefore(element, nextSibling);
        } else {
          parent.appendChild(element);
        }
      });
      removedElements.mobile = [];
    } else {
      document.querySelectorAll(".hide-desktop").forEach((el) => {
        removedElements.mobile.push({
          parent: el.parentNode,
          element: el,
          nextSibling: el.nextSibling,
        });
        el.remove();
      });

      removedElements.desktop.forEach(({ parent, element, nextSibling }) => {
        if (nextSibling && nextSibling.parentNode === parent) {
          parent.insertBefore(element, nextSibling);
        } else {
          parent.appendChild(element);
        }
      });
      removedElements.desktop = [];
    }
  }

  removeElementsByScreenSize();
  window.addEventListener("resize", removeElementsByScreenSize);
}

class StickyAddToCart extends HTMLElement {
  constructor() {
    super();
    this._handleResize = this._debounce(
      this.initStickyAddToCart.bind(this),
      200
    );
  }

  connectedCallback() {
    this.initStickyAddToCart();
    window.addEventListener("resize", this._handleResize);
  }
  disconnectedCallback() {
    window.removeEventListener("resize", this._handleResize);
  }

  initStickyAddToCart() {
    const img = this.querySelector(".product-content img");
    const selectField = this.querySelector('select[name="id"]');
    const addButton = this.querySelector('button[name="add"]');
    const productForm = document.querySelector(".product-form");
    if (!selectField || !addButton || !productForm) return;

    const addToCartText = addButton.getAttribute("data-add-to-cart");
    const soldOutText = addButton.getAttribute("data-sold-out");

    const checkVisibility = () => {
      const formRect = productForm.getBoundingClientRect();
      const footer = document.querySelector("footer");
      const footerRect = footer?.getBoundingClientRect();
      const isOutOfView = formRect.bottom <= 0;
      const isFooterVisible = footerRect && footerRect.top < window.innerHeight;

      if (isOutOfView && !isFooterVisible) {
        this.classList.add("show");
        document.documentElement.style.paddingBottom = `${this.clientHeight}px`;
      } else {
        this.classList.remove("show");
        document.documentElement.style.paddingBottom = "0";
      }
    };

    checkVisibility();
    window.addEventListener("scroll", checkVisibility);

    selectField.addEventListener("change", () => {
      const opt = selectField.options[selectField.selectedIndex];
      if (opt.dataset.img) img.setAttribute("src", opt.dataset.img);

      if (opt.getAttribute("data-available") === "false") {
        addButton.setAttribute("disabled", "true");
        addButton.querySelector("span").textContent = soldOutText;
      } else {
        addButton.removeAttribute("disabled");
        addButton.querySelector("span").textContent = addToCartText;
      }
    });

    document
      .querySelector('.product-form [name="id"]')
      ?.addEventListener("change", (e) => {
        const v = Number(e.target.value);
        if (v) selectField.value = v;
      });
  }

  _debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}
customElements.define("sticky-add-to-cart", StickyAddToCart);
